export default function Values() {
  const values = [
    {
      title: "Speed",
      desc: "Rapid delivery without compromising quality. We move fast because we know the market waits for no one.",
      icon: "ri-flashlight-line",
    },
    {
      title: "Transparency",
      desc: "You always know where your project stands. Clear reporting, honest communication, no surprises.",
      icon: "ri-eye-line",
    },
    {
      title: "Efficiency",
      desc: "Measurable results at every stage. Data-driven decisions that maximize ROI and minimize waste.",
      icon: "ri-line-chart-line",
    },
  ];

  return (
    <section className="relative w-full bg-cream-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {values.map((v) => (
            <div
              key={v.title}
              className="group bg-cream-100 rounded-2xl border border-ink-950/5 p-8 md:p-10 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-amber-100 mb-6 group-hover:bg-amber-200 transition-colors">
                <i className={`${v.icon} text-xl text-amber-600`}></i>
              </div>
              <h3 className="font-display font-bold text-xl md:text-2xl text-ink-950 mb-3">
                {v.title}
              </h3>
              <p className="text-sm md:text-base text-ink-700 leading-relaxed">
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}